import React, { useContext, useEffect } from 'react';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  makeStyles,
} from '@material-ui/core';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import BrightnessHighIcon from '@material-ui/icons/BrightnessHigh';
import Brightness4Icon from '@material-ui/icons/Brightness4';
import {
  enable as enableDarkMode,
  disable as disableDarkMode,
} from 'darkreader';

import { AppContext } from '../context/AppContext';

const useStyles = makeStyles({
  appBar_container: {
    gridArea: 'a',
  },
  content: {
    marginLeft: 'auto',
  },
});

export default function MyAppBar() {
  const { darkTheme: _darkTheme, sidebar: _sidebar } = useContext(AppContext);
  const [darkTheme, setDarkTheme] = _darkTheme;
  const setSidebar = _sidebar[1];

  const classes = useStyles();

  useEffect(() => {
    if (darkTheme) {
      enableDarkMode({
        brightness: 100,
        contrast: 90,
        sepia: 10,
      });

      localStorage.setItem('settings', JSON.stringify({ darkMode: true }));
    } else {
      disableDarkMode();
      localStorage.setItem('settings', JSON.stringify({ darkMode: false }));
    }
  }, [darkTheme]);

  return (
    <AppBar
      position='static'
      elevation={0}
      className={`${classes.appBar_container} appBar_edit`}
    >
      <Toolbar>
        <Typography variant='h6' noWrap>
          Chatty
        </Typography>

        <div className={classes.content}>
          <IconButton
            color='inherit'
            aria-label='open drawer'
            onClick={() => setSidebar(true)}
          >
            <AccountCircleIcon />
          </IconButton>
          <IconButton
            color='inherit'
            aria-label='change theme'
            onClick={() => setDarkTheme(!darkTheme)}
          >
            {darkTheme ? <BrightnessHighIcon /> : <Brightness4Icon />}
          </IconButton>
        </div>
      </Toolbar>
    </AppBar>
  );
}
